import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { isBrowser } from 'react-device-detect';
import { TimelineLite } from 'gsap';
import globals from '../globals';

class Button extends Component {

    handleMouseEnter(event) {
        if (this.props.dontWobble) {
            return;
        }

        let btn = event.currentTarget,
            tl = new TimelineLite();
        tl.to(btn, 0.1, {rotation: 2})
            .to(btn, 0.1, {rotation: -2})
            .to(btn, 0.1, {rotation: 2})
            .to(btn, 0.1, {rotation: -2})
            .to(btn, 0.1, {rotation: 0});
    }

    render() {
        const renderLink = () => {
            let image = <img src={this.props.image} alt={(this.props.alt ? this.props.alt : '')} />;

            if (typeof this.props.action === "function") {
                return (
                    <a href="#" onClick={this.props.action}>
                        {image}
                    </a>
                );
            } else if (this.props.action.includes('tel:')) {
            	if (isBrowser) {
					return (
						<Link to="/contact" onClick={() => globals.pushEvent('contactPhoneButtonClick')}>
							{image}
						</Link>
					);
				} else {
					return (
						<a href={this.props.action} onClick={() => globals.pushEvent('contactPhoneButtonClick')}>
							{image}
						</a>
					);
				}
            } else {
                return (
                    <Link to={this.props.action}>
                        {image}
                    </Link>
                );
            }
        };

        const buildClass = () => {
            let className = 'do-wobble';

            if (this.props.newClass)
                className += ' ' + this.props.newClass;

            return className;
        };

        return (
            <div className={buildClass()} onMouseEnter={this.handleMouseEnter.bind(this)}>
                {renderLink()}
                {this.props.children}
            </div>
        );
    }

}

export default Button;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Button.js